import {
  Box,
  CircularProgress, FormControlLabel,
  makeStyles,
} from "@material-ui/core";
import React, {useContext} from "react";
import {useState} from "react";
import {AppContext} from "../../../contexts/AppContext";
import assets from "../../../helpers/assets";
import Colors from "../../../helpers/Colors";
import {getFromStorage, saveToStorage} from "../../../services/LocalStorage";
import {updateLocationDeliveryConfig} from "../../../services/OrderService";
import Text from "../Text";
import {
  SELF_MANAGED_DELIVERY_PARTNER_NAME,
  STORAGE_KEY_IS_IN_SELF_MANAGED_MODE
} from "../../../helpers/Constants";
import {TickSwitch} from "../../common/CheckSwitch";

export function SelfManagedMode() {
  const {
    authData,
    kitchen,
    defaultDeliveryMode,
    availableDeliveryModes
  } = useContext(AppContext);

  const classes = useStyles();
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [isInSelfManageMode, setIsInSelfManageMode] = useState(
      getFromStorage(STORAGE_KEY_IS_IN_SELF_MANAGED_MODE));

  const onSelfModeChange = (isChecked) => {
    let loadedKitchen = kitchen;
    if (!loadedKitchen.id) {
      loadedKitchen = getFromStorage("kitchen");
    }
    setShowProgressBar(true)
    updateLocationDeliveryConfig(
        authData.signInUserSession.idToken.payload.partner_id,
        loadedKitchen.id,
        {
          locationId: loadedKitchen.id,
          defaultDeliveryMode,
          availableDeliveryModes,
          isInSelfManagedDeliveryMode: isChecked,
        }
    )
    .then((response) => {
      let mode = response.isInSelfManagedDeliveryMode;
      saveToStorage(STORAGE_KEY_IS_IN_SELF_MANAGED_MODE, mode);
      setIsInSelfManageMode(mode);
      setShowProgressBar(false)
    })
    .catch((error) => {
      console.log(error);
    });
  };

  return (
      <Box className={classes.container}>
        <Box className={classes.titleSection}>
          <img
              src={assets.bell.default}
              alt="bell-icon"
              className={classes.titleIcon}
          />
          <Text className={classes.title}>Delivery Request</Text>
        </Box>
        <Box className={classes.contentSection}>
          <Text>Switch to manual mode to handle all delivery requests manually
            by default. This overrides all delivery settings.</Text>
          <FormControlLabel className={classes.switchController}
                            control={<TickSwitch
                                isSwitchChecked={isInSelfManageMode}
                                onSwitchChange={(val) => onSelfModeChange(val)}
                                isDisabled={showProgressBar}/>}
                            label={SELF_MANAGED_DELIVERY_PARTNER_NAME}
                            labelPlacement={"start"}
                            disabled={showProgressBar}/>
        </Box>
        <Box className={classes.progress}
             style={{display: showProgressBar ? "flex" : "none"}}>
          <CircularProgress/>
        </Box>
      </Box>
  );
}

const useStyles = makeStyles((_) => ({
  container: {
    color: Colors.textColor,
    padding: 25,
    fontFamily: "SFProDisplay-Medium",
    display: "flex",
    flexDirection: "column",
    height: "100%"
  },
  titleSection: {
    display: "flex",
    alignItems: "center",
    marginBottom: 12,
  },
  titleIcon: {
    width: 20,
    height: 20,
    marginRight: 12,
  },
  contentSection: {
    marginLeft: 32,
    fontSize: 14,
  },
  radioGroup: {
    marginTop: 12,
    "& .MuiRadio-root": {
      color: "#1C1B1F",
    },
    "& .Mui-checked": {
      color: Colors.grubtechBlue,
    },
    "& .Mui-disabled": {
      color: Colors.textColor,
      opacity: 0.7,
    },
  },
  title: {
    fontFamily: "SFProDisplay-Bold",
    fontSize: 24,
  },
  progress: {
    display: "flex",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    "& .MuiCircularProgress-circle": {
      color: Colors.grubtechBlue
    }
  },
  switchController: {
    paddingTop: 10,
    marginLeft: 0
  }
}));
